const txteng16 = [
  ["Я получила письмо от его жены", "I got an email from his wife"],
  ["Ты получил мое письмо?", "Did you get my email?"],
  ["Ты получил мое сообщение?", "Did you get my message?"],
  [
    "Я получила письмо от твоего отца сегодня и порвала его",
    "I got a letter from your father today and I tore it up.",
  ],
  ["Что тебе принести?", "What can I get you?"],
  ["Принести что-нибудь выпить?", "Can I get you anything to drink?"],
  ["Что-нибудь еще? (будете есть)", "Can I get you anything else?"],
  ["Можете принести кетчуп?", "Can you get me some ketchup?"],
  ["Где ты его взял (купил)?", "Where did you get it?"],
  ["Ты купил цветы?", "Did you get the flowers?"],
  ["Давай выпьем кофе", "Let's get some coffee."],
  ["Пойдем, выпьем кофе. Я угощаю.", "Let's go get some coffee. My treat."],
  ["Я позову его для тебя", "I'll get him for you"],
  ["Позовите менеджера", "Let's get the manager"],
  ["Вы понимаете меня?", "Do you get me?"],
  ["Я не понимаю тебя.", "I don't get you."],
  ["Ты понял шутку?", "Did you get the joke?"],
  ["Ты должен найти работу.", "You gotta get a job."],
  ["Ты нашел работу?", "Did you get the job?"],
];

export default txteng16;
